export default __webpack_public_path__ + "static/media/exploreRight.4be5545d.png";